<lib-wall-decor-scene-creator [availableImages]="availableImages$ | async"
                              [contextId]="publicSessionId$ | async"
                              [context]="context"
                              [rounding]="rounding$ | async"
                              [preConfigValue]="preConfig$ | async"
                              [preConfig]="preset"
                              [isUpdate]="isUpdate"
                              (closed)="closed.emit()"
                              [type]="type"
                              [limitPersonalization]="limitPersonalization$ | async"
                              [photoRatio]="photoRatio"
                              [currentLookBookConfigId]="currentLookBookConfigId"
                              [imageRelations]="photoGroupHasPhoto$ | async"></lib-wall-decor-scene-creator>
